import { HttpClient } from './serviceBase';

class BusinessService {
    GetAll = async () =>
        await HttpClient.Get(`/api/businesses`);

    GetPaymentsMethods = async (businessId, subChannel) => {
        return await HttpClient.Get(`/api/businesses/${businessId}?subChannel=${subChannel}`);
    }
}

export default new BusinessService();